<template>
	<div id="m_wdxz">
		<div class="m_kind">
			<div class="imgfm" style="float: left;">
				<img :src="imgsrc" width="250" height="350" :onerror="errorImg">
				<!-- <crop_fm></crop_fm> -->
			</div>
			<div class="float-right">
				<div class="line" style="">
					<div class="cropper-content" style="">
						<div class="cropper">
							<vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true"
							 :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original"
							 :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"
							 :fixedBox="option.fixedBox" @realTime="realTime" @imgLoad="imgLoad"></vueCropper>
						</div>
					</div>
				</div>
				<center>
					<div class="crop-btn">
						<label class="crop-select-btn" for="uploads">选择</label>
						<input type="file" id="uploads" :value="imgFile" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg"
						 @change="uploadImg($event, 1)">
						<input type="button" class="oper" value="+" title="放大" @click="changeScale(1)">
						<input type="button" class="oper" value="-" title="缩小" @click="changeScale(-1)">
						<label class="crop-select-btn" @click="finish('blob')">裁剪</label>

					</div>
				</center>
			</div>
			<div class="clearfix"></div>

			<center><input @click="uploadinfor" type="button" class="g-btn" value="保存"></center>

		</div>

	</div>
</template>

<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'

	export default {
		data() {
			return {
				errorImg: 'this.src="' + require('../../../assets/mrimg.png') + '"', //未上传时显示默认图片
				imgsrc: '',
				crap: false,
				previews: {},
				option: {

					infoTrue: true,
					img: '',
					outputSize: 1, //剪切后的图片质量（0.1-1）
					full: true, //输出原图比例截图 props名full
					outputType: 'jpeg',
					canMove: true, //能否拖动图片
					original: true, //是否显示原始宽高
					enlarge: 1,
					centerBox: true, // 截图框能否超过图片
					canMoveBox: false, //能否拖动截图框
					autoCrop: true, //是否自动生成截图框
					autoCropWidth: 250,
					autoCropHeight: 350,
					fixedBox: true, // 固定大小 禁止改变截图框大小


				},
				fileName: '', //本机文件地址
				imgFile: '',
				uploadImgRelaPath: '', //上传后的图片的地址（不带服务器域名）
				uid: storage.get('userdata')
			}
		},
		methods: {
			changeScale(num) {

				num = num || 1;
				this.$refs.cropper.changeScale(num);
			},

			finish(type) {

				let _this = this;
				// 输出
				if (type === 'blob') {
					this.$refs.cropper.getCropBlob((data) => {
						let img = window.URL.createObjectURL(data)
						this.model = true;
						this.modelSrc = img;
						//将获取到的裁剪后图片信息转成base64格式
						var image = new Image();
						var vm = this
						var reader = new FileReader();
						reader.readAsDataURL(data);
						reader.onload = function(e) {
							vm.imgsrc = e.target.result //将base64信息赋值给需要显示图片的字段
						}
					})
				} else {
					this.$refs.cropper.getCropData((data) => {
						this.model = true;
						this.modelSrc = data;
					})
				}
			},

			// 实时预览函数
			realTime(data) {

				this.previews = data
			},
			//选择本地图片
			uploadImg(e, num) {
				var _this = this;
				var file = e.target.files[0]
				_this.fileName = file.name;
				if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
					alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
					return false
				}
				var reader = new FileReader();
				reader.onload = (e) => {
					let data;
					if (typeof e.target.result === 'object') {
						// 把Array Buffer转化为blob 如果是base64不需要
						data = window.URL.createObjectURL(new Blob([e.target.result]))
					} else {
						data = e.target.result
					}
					if (num === 1) {
						_this.option.img = data
					} else if (num === 2) {
						_this.example2.img = data
					}
				}
				reader.readAsArrayBuffer(file);

			},
			imgLoad(msg) {

			},
			uploadinfor() {

				var api="https://api.yopoo.cn/api/centre/photogallery"

				Axios.post(api,{"picture":this.imgsrc,"category":3}).then((res)=>{
					if(res.data.code==200){
						this.$message({
							message: res.data.msg,
							type: 'success',
							center: true
						});
						setTimeout(()=>{
							location.reload()
						},1000)
					}
					if(res.data.code==202){
						this.$message({
							message: res.data.msg,
							type: 'error',
							center: true
						});
					}

				})
				// storage.set('imgsrc3',this.imgsrc)
// 				setTimeout(()=>{
// 					location.reload()
// 				},200)
			}
		},

	}
</script>
<style lang="less">
	#cropper {
		width: 1000px;
		margin: 0 auto;
	}

	.info {
		width: 720px;
		margin: 0 auto;

		.oper-dv {
			height: 20px;
			text-align: right;
			margin-right: 100px;

			a {
				font-weight: 500;

				&:last-child {
					margin-left: 30px;
				}
			}
		}

		.info-item {
			margin-top: 15px;

			label {
				display: inline-block;
				width: 100px;
				text-align: right;
			}

			.sel-img-dv {
				position: relative;

				.sel-file {
					position: absolute;
					width: 90px;
					height: 30px;
					opacity: 0;
					cursor: pointer;
					z-index: 2;
				}

				.sel-btn {
					position: absolute;
					cursor: pointer;
					z-index: 1;
				}
			}
		}
	}

	.cropper-content {
		// 		display: flex;
		// 		display: -webkit-flex;
		// 		justify-content: flex-end;
		// 		-webkit-justify-content: flex-end;

		.cropper {
			width: 250px;
			height: 350px;
		}

		.show-preview {
			flex: 1;
			-webkit-flex: 1;
			display: flex;
			display: -webkit-flex;
			justify-content: center;
			-webkit-justify-content: center;

			.preview {
				overflow: hidden;
				border-radius: 50%;
				border: 1px solid #cccccc;
				background: #cccccc;
				margin-left: 40px;
			}
		}
	}

	.cropper-content .show-preview .preview {
		margin-left: 0;
	}
	.m_kind {
		width: 700px;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/per_admin/per_modify/M_Advpic.vue